import { render, staticRenderFns } from "./SchoolTopbarSection.vue?vue&type=template&id=1d7402d7&"
import script from "./SchoolTopbarSection.vue?vue&type=script&lang=js&"
export * from "./SchoolTopbarSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports